import {
  ChartInsight,
  isCatalystInsight,
  isEarningsInsight,
} from '@toggle/toggle';

export const getInsightEntityTag = (insight: ChartInsight): string => {
  const isCatalyst = isCatalystInsight(insight);
  const isEarnings = isEarningsInsight(insight);

  if (isEarnings) {
    return insight.entity_tag;
  } else if (isCatalyst) {
    return insight.identifier || '';
  } else {
    return insight.metadata.entity;
  }
};
